/* ============================================================
   Double D's Archery Theme — Frontend JS
   ============================================================ */
(function () {
  'use strict';

  /* Sticky header shadow on scroll */
  var header = document.querySelector('.header-wrap');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 4) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Rotating announcement bar */
  var messages = document.querySelectorAll('.announce-msg');
  if (messages.length > 1) {
    var currentMsg = 0;
    var rotateTimer;
    var showMsg = function (idx) {
      messages.forEach(function (m, i) { m.classList.toggle('active', i === idx); });
      currentMsg = idx;
    };
    var startAutoRotate = function () {
      rotateTimer = setInterval(function () {
        var next = (currentMsg + 1) % messages.length;
        showMsg(next);
      }, 4500);
    };
    window.rotateAnnounce = function (direction) {
      clearInterval(rotateTimer);
      var next = currentMsg + direction;
      if (next < 0) next = messages.length - 1;
      if (next >= messages.length) next = 0;
      showMsg(next);
      startAutoRotate();
    };
    startAutoRotate();
  }

  /* Quantity steppers (universal — works on featured product, PDP, cart) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-btn');
    if (!btn) return;
    var stepper = btn.closest('.qty-stepper');
    if (!stepper) return;
    var input = stepper.querySelector('.qty-input');
    if (!input) return;
    var delta = btn.dataset.delta ? parseInt(btn.dataset.delta, 10) : 0;
    var min = parseInt(input.min || '1', 10);
    var current = parseInt(input.value || '1', 10);
    var next = Math.max(min, current + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Search drawer */
  var searchOpen = document.querySelectorAll('[data-open-search]');
  var searchDrawer = document.querySelector('.search-drawer');
  var searchClose = document.querySelectorAll('[data-close-search]');
  if (searchDrawer) {
    searchOpen.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        searchDrawer.classList.add('open');
        var input = searchDrawer.querySelector('input[type=search],input[type=text]');
        if (input) setTimeout(function () { input.focus(); }, 50);
      });
    });
    searchClose.forEach(function (b) {
      b.addEventListener('click', function () { searchDrawer.classList.remove('open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') searchDrawer.classList.remove('open');
    });
  }

  /* Featured product / PDP — thumbnail swap */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var imgUrl = thumb.dataset.thumb;
      var target = document.querySelector(thumb.dataset.target || '.product-media img');
      if (!target || !imgUrl) return;
      target.src = imgUrl;
      var siblings = thumb.parentElement.querySelectorAll('.product-thumb');
      siblings.forEach(function (s) { s.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* FAQ accordion */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.faq-q');
    if (!btn) return;
    var item = btn.closest('.faq-item');
    if (!item) return;
    item.classList.toggle('open');
    btn.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
  });

  /* NOTE: Variant selector logic now lives in sections/main-product.liquid
     (radio swatches with live price, image swap, and thumbnail filtering).
     The old <select> dropdown handler was removed to prevent crashes. */
})();